export default __webpack_public_path__ + "bf970bfa4d37497ae523f68a9e4896dd.svg";